import { User, Building, Briefcase } from "lucide-react"

const userTypes = [
  {
    icon: User,
    title: "Individual Land Buyer",
    description: "Buying your first plot or investing in land? Get clarity on flood risk, legal status, and fair market value before signing any agreement.",
    features: ["Verify flood and legal safety", "Check if the price is fair", "Understand terrain buildability"],
  },
  {
    icon: Building,
    title: "Bank / Financial Analyst",
    description: "Evaluating land as collateral for a mortgage or loan? LANDRISK provides standardized risk scoring for faster, more confident lending decisions.",
    features: ["Standardized risk reports", "Collateral risk assessment", "Portfolio-level analysis"],
  },
  {
    icon: Briefcase,
    title: "Developer / Lawyer",
    description: "Conducting due diligence for a client or development project? Access comprehensive environmental, legal, and topographical data in one place.",
    features: ["Legal red-flag scanning", "Environmental compliance data", "Detailed terrain analysis"],
  },
]

export function UserTypes() {
  return (
    <section className="border-b border-border py-20">
      <div className="mx-auto max-w-7xl px-4 lg:px-8">
        <div className="text-center">
          <h2 className="text-balance text-3xl font-bold tracking-tight text-foreground sm:text-4xl">
            Built for Every Stakeholder
          </h2>
          <p className="mt-3 text-pretty text-muted-foreground">
            Whether you are buying, lending, or advising — LANDRISK has you covered
          </p>
        </div>

        <div className="mt-14 flex flex-col gap-6 md:flex-row">
          {userTypes.map((type) => (
            <div
              key={type.title}
              className="flex flex-1 flex-col rounded-xl border border-border bg-card p-8 transition-shadow hover:shadow-md"
            >
              <div className="flex size-12 items-center justify-center rounded-xl bg-primary/10 text-primary">
                <type.icon className="size-6" />
              </div>
              <h3 className="mt-5 text-lg font-semibold text-foreground">
                {type.title}
              </h3>
              <p className="mt-2 text-sm text-muted-foreground leading-relaxed">
                {type.description}
              </p>
              <ul className="mt-5 flex flex-col gap-2">
                {type.features.map((feature) => (
                  <li key={feature} className="flex items-center gap-2 text-sm text-foreground">
                    <span className="flex size-5 shrink-0 items-center justify-center rounded-full bg-primary/10 text-primary text-[10px]">
                      {"✓"}
                    </span>
                    {feature}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
